document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-rvac-calculator]').forEach((root) => {
    const i18n = JSON.parse(root.querySelector('[data-rvac-i18n]')?.textContent || '{}');

    function t(template, vars = {}) {
      if (!template) return '';
      return Object.keys(vars).reduce(
        (str, key) => str.replace(new RegExp(`\\{\\{\\s*${key}\\s*\\}\\}`, 'g'), vars[key]),
        template
      );
    }

    const BATTERY_RATES = {
      lifepo4: 0.9,
      agm: 0.6
    };

    const state = {
      inputValue: '',
      dcVoltage: '12',
      batteryCapacity: '',
      batteryType: 'lifepo4'
    };

    const el = (name) => root.querySelector(`[data-field="${name}"]`);
    const powerInput = el('power-input');
    const voltageInput = el('dc-voltage');
    const batteryInput = el('battery-capacity');
    const calculateBtn = el('calculate-btn');
    const resultsSection = el('results-section');
    const batteryCards = root.querySelectorAll('[data-battery-type]');

    if (voltageInput?.value) {
      state.dcVoltage = voltageInput.value;
    }

    function updateCalculateButton() {
      const hasValues = state.inputValue && state.dcVoltage && state.batteryCapacity;
      if (calculateBtn) calculateBtn.disabled = !hasValues;
    }

    function formatNumber(num, decimals) {
      return num.toFixed(decimals);
    }

    function displayResults(current, usable, runtime, voltage, totalBattery, dischargeRate) {
      const batteryLabels = i18n.battery_labels || { lifepo4: 'LiFePO₄', agm: 'AGM/GEL' };
      const batteryTypeLabel = batteryLabels[state.batteryType] || state.batteryType;
      const dischargePercent = (dischargeRate * 100).toFixed(0);
      const voltageLabel = formatNumber(voltage, 1);

      if (el('result-current-label')) {
        el('result-current-label').textContent = t(i18n.dynamic?.running_current_label, {
          voltage: voltageLabel
        }) || `Running Current (${voltageLabel}V)`;
      }
      if (el('result-current')) el('result-current').textContent = `${formatNumber(current, 1)}A`;
      if (el('result-usable')) el('result-usable').textContent = `${formatNumber(usable, 0)}Ah`;
      if (el('result-usable-note')) {
        el('result-usable-note').textContent = t(i18n.dynamic?.usable_note, {
          capacity: totalBattery,
          percent: dischargePercent,
          type: batteryTypeLabel
        });
      }
      if (el('result-runtime')) el('result-runtime').textContent = formatNumber(runtime, 1);
      if (el('result-note')) {
        el('result-note').textContent = t(i18n.dynamic?.result_note, {
          type: batteryTypeLabel,
          percent: dischargePercent
        });
      }

      resultsSection?.classList.add('show');
      resultsSection?.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }

    function calculate() {
      const powerNum = parseFloat(state.inputValue);
      const voltageNum = parseFloat(state.dcVoltage);
      const batteryNum = parseFloat(state.batteryCapacity);

      if (
        isNaN(powerNum) ||
        isNaN(voltageNum) ||
        isNaN(batteryNum) ||
        powerNum <= 0 ||
        voltageNum <= 0 ||
        batteryNum <= 0
      ) {
        alert(
          i18n.alerts?.invalid_numbers ||
            'Please enter valid positive numbers for power, DC system voltage, and battery capacity'
        );
        return;
      }

      const dischargeRate = BATTERY_RATES[state.batteryType];
      const runningCurrent = powerNum / voltageNum;
      const usableCapacity = batteryNum * dischargeRate;
      const runtimeHours = usableCapacity / runningCurrent;

      displayResults(runningCurrent, usableCapacity, runtimeHours, voltageNum, batteryNum, dischargeRate);
    }

    batteryCards.forEach((card) => {
      card.addEventListener('click', () => {
        batteryCards.forEach((c) => c.classList.remove('active'));
        card.classList.add('active');
        state.batteryType = card.dataset.batteryType;
      });

      card.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          card.click();
        }
      });
    });

    powerInput?.addEventListener('input', (e) => {
      state.inputValue = e.target.value;
      updateCalculateButton();
    });

    voltageInput?.addEventListener('input', (e) => {
      state.dcVoltage = e.target.value;
      updateCalculateButton();
    });

    batteryInput?.addEventListener('input', (e) => {
      state.batteryCapacity = e.target.value;
      updateCalculateButton();
    });

    calculateBtn?.addEventListener('click', calculate);

    updateCalculateButton();
  });
});
